import { BookkeepingTagDbValue } from '../types/bookkeepingTagDbValue'
import { BookkeepingTagNavItemValue } from '../types/bookkeepingTagNavItemValue'
import { removeVatRatesFromBookkeepingTag } from './removeVatRatesFromBookkeepingTag'

export const convertBookkeepingTagNavItemValueToDbValue = (
  navItemValue: BookkeepingTagNavItemValue,
): BookkeepingTagDbValue | undefined => {
  if (!navItemValue.tag || !navItemValue.response) {
    return undefined
  }

  const responseWithoutVatRates = removeVatRatesFromBookkeepingTag(navItemValue.response)
  const tagId = navItemValue.tag.id

  return {
    answer: responseWithoutVatRates,
    name: navItemValue.tag.name,
    tagId,
  }
}
